import { useEffect, useRef, useState } from "react";
import { api } from "./api";

// Server/client clock offset (ms). Protects countdowns from wrong device clocks.
let offset = 0;
let lastSync = 0;
let syncing = null;

export function serverNow() {
  return Date.now() + offset;
}

export function syncServerClock(force = false) {
  const age = Date.now() - lastSync;
  if (!force && lastSync && age < 60000) return Promise.resolve(offset);
  if (syncing) return syncing;
  const t0 = Date.now();
  syncing = api
    .get("/time")
    .then(({ data }) => {
      const rtt = Date.now() - t0;
      const server = new Date(data.now).getTime();
      if (!Number.isNaN(server)) {
        offset = server + rtt / 2 - Date.now();
        lastSync = Date.now();
      }
      return offset;
    })
    .catch(() => offset)
    .finally(() => { syncing = null; });
  return syncing;
}

/** One shared 1s ticker returning server-synced "now" (ms). Re-syncs on resume. */
export function useServerTick(active = true) {
  const [now, setNow] = useState(() => serverNow());
  const timer = useRef(null);
  useEffect(() => {
    if (!active) return;
    let cancelled = false;
    const tick = () => { if (!cancelled) setNow(serverNow()); };
    syncServerClock().then(tick);
    timer.current = setInterval(tick, 1000);
    const onResume = () => {
      if (document.visibilityState === "visible") syncServerClock(true).then(tick);
    };
    document.addEventListener("visibilitychange", onResume);
    window.addEventListener("focus", onResume);
    window.addEventListener("online", onResume);
    return () => {
      cancelled = true;
      clearInterval(timer.current);
      document.removeEventListener("visibilitychange", onResume);
      window.removeEventListener("focus", onResume);
      window.removeEventListener("online", onResume);
    };
  }, [active]);
  return now;
}

export function mmss(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  return `${String(m).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
}
